document.addEventListener("DOMContentLoaded", function () {
    const scrollBtn = document.getElementById("scroll-to")

    scrollBtn?.addEventListener("click", () => {
        window.scrollBy({
          top: 650,
          left: 0,
          behavior: "smooth",
        });
    });

});